var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"navbar-nav mr-auto"},_vm._l((_vm.tabs),function(tab){return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":'nav-option-'+tab.field},on:{"click":function($event){return _vm.nav_change(tab.field)}}},[_vm._v("\n\t\t\t\t"+_vm._s(tab.label)+"\n\t\t")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }